module.exports = __webpack_public_path__ + "img/chess-knight-piece.1bb97377.svg";